import React, { Component } from "react"
import Modal from "react-responsive-modal"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"
import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons"

class DatePicker extends Component {
	constructor(props) {
		super(props)
		this.state = {
			mois: new Date().getMonth(),
			annee: new Date().getFullYear(),
		}
		this.today = moment()
		this.days = [
			"Lundi",
			"Mardi",
			"Mercredi",
			"Jeudi",
			"Vendredi",
			"Samedi",
			"Dimanche",
		]
		this.months = [
			"Janvier",
			"Février",
			"Mars",
			"Avril",
			"Mai",
			"Juin",
			"Juillet",
			"Août",
			"Septembre",
			"Octobre",
			"Novembre",
			"Décembre",
		]
		this.years = Array.from(
			{
				length:
					parseInt(moment().format("YYYY")) +
					1 -
					this.props.startAnnee +
					1,
			},
			(_, k) => k + this.props.startAnnee,
		)
	}

	createCalendar = (month, year) => {
		let cal = []
		let week = []
		let k = 1
		let startOfMonth = moment()
			.set({ year: year, month: month })
			.startOf("month")
			.day()
		if (startOfMonth === 0) startOfMonth = 7
		let endOfMonth = moment()
			.set({ year: year, month: month })
			.endOf("month")
			.day()
		let startOfCalendar = moment()
			.set({ year: year, month: month })
			.startOf("month")
			.subtract(startOfMonth - 1, "days")
		let endOfCalendar = moment()
			.set({ year: year, month: month })
			.endOf("month")
			.add(7 - endOfMonth, "days")
		for (
			let day = startOfCalendar;
			day < endOfCalendar;
			day.add(1, "days")
		) {
			let d = moment(day.format("DD-MM-YYYY"), "DD-MM-YYYY")
			week.push(d)
			if (day.day() === 0 && k > 6) {
				cal.push([...week])
				week = []
			}
			k++
		}
		return cal
	}

	changeMonth = (add) => {
		const { mois, annee } = this.state
		let newMois,
			newAnnee = annee
		if (add) {
			if (mois < 11) newMois = mois + 1
			else {
				newMois = 0
				newAnnee = annee + 1
			}
		} else {
			if (mois > 0) newMois = mois - 1
			else {
				newMois = 11
				newAnnee = annee - 1
			}
		}
		this.setState({ mois: newMois, annee: newAnnee })
	}

	updateState = (key, value) => {
		let state = Object.assign({}, this.state)
		state[key] = value
		this.setState({ ...state })
	}

	clickDate = (moment) => {
		this.props.func(moment.format("DD-MM-YYYY"))
		this.props.closeModal()
	}

	render() {
		const { visible, closeModal } = this.props
		const { annee, mois } = this.state
		return (
			<Modal
				center={true}
				focusTrapped={false}
				open={visible}
				onClose={closeModal}
				showCloseIcon={false}
				classNames={{ overlay: "overlay", modal: "modal-calendar" }}
			>
				<div className="calendrier-small">
					<div className="row sb">
						<button
							type="button"
							className="norm-btn blue1"
							onClick={() => this.changeMonth(false)}
							disabled={annee === 2020 && mois === 0}
						>
							<FontAwesomeIcon icon={faChevronLeft} />
						</button>
						<div className="row">
							<select
								value={mois}
								onChange={(e) =>
									this.updateState(
										"mois",
										parseInt(e.target.value),
									)
								}
							>
								{this.months.map((month, index) => (
									<option key={`mois${month}`} value={index}>
										{month}
									</option>
								))}
							</select>
							<select
								value={annee}
								onChange={(e) =>
									this.updateState(
										"annee",
										parseInt(e.target.value),
									)
								}
							>
								{this.years.map((year) => (
									<option key={`annee${year}`} value={year}>
										{year}
									</option>
								))}
							</select>
						</div>
						<button
							type="button"
							className="norm-btn blue1"
							onClick={() => this.changeMonth(true)}
							disabled={
								annee === this.years[this.years.length - 1] &&
								mois === 11
							}
						>
							<FontAwesomeIcon icon={faChevronRight} />
						</button>
					</div>
					<div className={`row`}>
						{this.days.map((day) => (
							<div key={`jour${day}`} className="header">
								{day.substring(0, 3)}
							</div>
						))}
					</div>

					{this.createCalendar(mois, annee).map((week, index) => (
						<div
							key={`row${index}`}
							className={`row calendrier-row${false ? " hidden" : ""}`}
						>
							{week.map((moment, index) => (
								<div
									key={`calend${moment.date()}${index}`}
									className={`calendrier-case${moment.month() !== mois ? " not-month" : ""}`}
								>
									<button
										type="button"
										className={`day-btn${this.today.isSame(moment, "day") ? " today" : ""}`}
										onClick={() => this.clickDate(moment)}
										style={{
											height: "32px",
											width: "48px",
										}}
									>
										{moment.date()}
									</button>
								</div>
							))}
						</div>
					))}
				</div>
			</Modal>
		)
	}
}

export default DatePicker
